import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { RHFSwitchField } from '@openx/components-core/lib/SwitchField/RHFSwitchField';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form';
import { useTranslation } from 'react-i18next';
import { organizationFields } from '../../../constants';

export const PixelSection = () => {
  const { t } = useTranslation();

  return (
    <FormSection
      description={t('Events tracked by the OpenX Pixel for retargeting.')}
      title={t('Pixel')}
      rightColumnSize={RIGHT_COLUMN_WIDTH}
    >
      <RHFSwitchField
        data-test="enable-retargeting"
        label={t('Enable Retargeting')}
        margin="dense"
        name={organizationFields.RETARGETING_ENABLED}
      />
    </FormSection>
  );
};
